module.exports = "<meta name=\"apple-itunes-app\" content=\"app-id={{ appId() }}, app-argument={{ appArgument() }}\">\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/smartBanner/template.html
// module id = 867
// module chunks = 1